// Foot measurement slider (cm). `value === null` means "not measured": the
// thumb rests on a neutral default and the value reads "Not set" until moved.
export default function FootSlider({
  label,
  min,
  max,
  step = 0.1,
  restAt,
  value = null,
  onChange,
  clearable = true,
  hint,
  testid,
}) {
  const isSet = value !== null && value !== undefined;
  const shown = isSet ? value : restAt;
  const pct = ((shown - min) / (max - min)) * 100;

  return (
    <div data-testid={testid}>
      <div className="flex items-end justify-between gap-3">
        <label htmlFor={`${testid}-range`} className="text-[10.5px] uppercase tracking-[0.2em] text-neutral-500">
          {label}
        </label>
        <div className="flex items-baseline gap-2">
          <span
            data-testid={`${testid}-value`}
            className={`text-[22px] font-medium tracking-[-0.02em] tabular-nums leading-none ${
              isSet ? "text-[#0A0A0A]" : "text-neutral-300"
            }`}
          >
            {isSet ? `${Number(value).toFixed(1)} cm` : "Not set"}
          </span>
          {isSet && clearable && (
            <button
              type="button"
              data-testid={`${testid}-clear`}
              onClick={() => onChange(null)}
              className="text-[11px] text-neutral-400 hover:text-[#0A0A0A] transition-colors"
            >
              Clear
            </button>
          )}
        </div>
      </div>
      <input
        id={`${testid}-range`}
        data-testid={`${testid}-range`}
        type="range"
        min={min}
        max={max}
        step={step}
        value={shown}
        onChange={(e) => onChange(Math.round(parseFloat(e.target.value) * 10) / 10)}
        className={`fit-range mt-3 w-full ${isSet ? "" : "is-unset"}`}
        style={{ "--fill": `${Math.max(0, Math.min(100, pct))}%` }}
      />
      <div className="mt-1 flex justify-between text-[10.5px] text-neutral-400 tabular-nums">
        <span>{min} cm</span>
        {hint && <span className="text-neutral-500">{hint}</span>}
        <span>{max} cm</span>
      </div>
    </div>
  );
}
